<template>
    <div id="password-recovery">
        <div id="recovery-wrapper">
            <div class="section-name-default">
                <i class="mi mi-arrow-back btn-back" @click="$router.back()"></i>Resetowanie hasła
            </div>
            <div class="reset-container">
                <p class="reset-info">Podaj adres e-mail na który wysłane zostaną instrukcje.</p>
                <div class="reset-data">
                    <input class="input-default" :class="{'input-error': emailError}" placeholder="Podaj e-mail..."
                           v-model="email" @keyup="debounce(validateEmailField)">
                    <button class="btn-outline-blue btn-send" @click="resetPassword">WYŚLIJ</button>
                </div>
                <div class="errors">{{ emailError }}</div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
#password-recovery {

    #recovery-wrapper {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: fit-content;
        width: -moz-max-content;
    }

    .reset-container {
        display: flex;
        flex-flow: column;

        .reset-info {
            font-weight: 300;
            font-size: 18px;
        }
        .reset-data {
            display: flex;
            align-items: center;

            .input-default {
                min-width: 300px;
                margin-bottom: 0;
            }
            .btn-send {
                margin-left: 1em;
            }
        }
        .errors {
            margin-top: 0.5em;
            margin-left: 1em;
        }
    }
}
</style>

<script>
import {
    API_PASSWORD_RESET_URL,
    FIELD_ERRORS,
} from '../constants.js'
import {
    isValidEmail,
} from '../utils.js'

export default {
    name: 'PasswordRecovery',
    data() {
        return {
            email: '',
            emailError: '',
        }
    },
    methods: {
        validateEmailField() {
            this.emailError = !this.email
                ? FIELD_ERRORS.REQUIRED
                : !isValidEmail(this.email)
                    ? FIELD_ERRORS.EMAIL
                    : '';
        },
        resetPassword() {
            this.validateEmailField();

            if (!this.emailError) {
                const headers = {'Content-Type': 'application/x-www-form-urlencoded'};
                this.$http.post(API_PASSWORD_RESET_URL, `email=${this.email}`, {headers}).then(() => {
                    this.$app.showSuccessAlert('Na podany adres e-mail wysłane zostały dalsze instrukcje.');
                    this.$router.back();
                });
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// PasswordRecovery.vue?3f0e8efc